export class AnalyticsFilters {
  surveys_form_id: string | undefined = undefined
  teams: number[] = []
  locations: number[] = []

  constructor(
    surveys_form_id: string | undefined = undefined,
    teams: number[] = [],
    locations: number[] = []
  ) {
    this.surveys_form_id = surveys_form_id
    this.teams = teams
    this.locations = locations
  }
}
